/**
 * Pulls the TrueLayer payment id out of an authorise URL.
 *
 * TrueLayer carries it in the fragment rather than the query string:
 * `https://payment.truelayer.com/payments#payment_id=…&resource_token=…`.
 * The query string is checked too, so a change of shape at their end does not
 * silently return nothing.
 */
export function parsePaymentId(authoriseUrl: string): string {
  if (!authoriseUrl) return '';

  try {
    const url = new URL(authoriseUrl);
    const fromQuery = url.searchParams.get('payment_id');
    if (fromQuery) return fromQuery;

    const fragment = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash;
    return new URLSearchParams(fragment).get('payment_id') ?? '';
  } catch {
    return '';
  }
}
